module.exports = __webpack_public_path__ + "static/gavilanwork2-01cc85d1c77adcd02edadf78a8168dd8.jpg";